<template>
	<header>
		<HomeBtn/>

		<Tabs/>

		<div class="choices pixelart">
			<div class="choice-tile"><div class="choice-tile-img choice-character-bg" :style="{ backgroundImage : `url(${currentCharacterImageUrl})` }"></div></div>
			<div class="choice-tile"><div class="choice-tile-img choice-weapon-bg" :style="{ backgroundImage : `url(${currentPrimaryImg})` }"></div></div>
			<div class="choice-tile"><div class="choice-tile-img choice-weapon-bg" :style="{ backgroundImage : `url(${currentSecondaryImg})` }"></div></div>
		</div>
	</header>
</template>

<script>
import Tabs from '@/components/Tabs'
import HomeBtn from '@/components/HomeBtn'
import npc from '@/modules/data/npc'
import weapons from '@/modules/data/weapons'

export default {
	name: 'Logo',
	components: {
		Tabs,
		HomeBtn
	},
	data() {
		return {
			version: '1.4.0'
		}
	},
	computed: {
		currentCharacterImageUrl()
		{
			const currentCharacterId = this.$store.getters.getCharacterId;
			const currentCharacterSprite = npc[currentCharacterId].sprite;

			return require( `@/assets/sprites/npc/${currentCharacterSprite}.png` );
		},
		currentPrimaryImg()
		{
			const currentPrimaryIndex = this.$store.getters.getPrimaryWeapon;
			const currentPrimary = weapons.filter( w => w.index === currentPrimaryIndex )[0];

			return this.getWeaponImageUrl( currentPrimary.pickup_str );
		},
		currentSecondaryImg()
		{
			const currentSecondaryIndex = this.$store.getters.getSecondaryWeapon;
			const currentSecondary = weapons.filter( w => w.index === currentSecondaryIndex )[0];

			return this.getWeaponImageUrl( currentSecondary.pickup_str );
		},
	},
	methods: {
		getWeaponImageUrl( pickup_str )
		{
			return ( pickup_str && pickup_str !== -1 ) ? require( `@/assets/sprites/weapon/${pickup_str}.png` ) : '';
		},

	}
}
</script>

<style lang="scss" scoped>
	header {
		padding: 0 20px;
		display: flex;
		align-items: center;
		background-color: #1c1e1f;
		box-shadow: 0px 5px 5px #151718;
		position: sticky;
		top: 0;
		z-index: 1;
	}

	// Logo
	// ================================

	.logo-section {
		text-align: center;
	}

	.logo {
		height: 24px;
		width: 24px;
		margin: 0 auto;
		display: block;
	}

	.logo-text {
		font-size: 1.4rem;
	}


	// Choices
	// ================================

	.choices {
		display: flex;
	}

	.choice-tile {
		align-items: center;
		background-color: #383d3f;
		border: 1px solid #615c5c;
		display: flex;
		height: 48px;
		justify-content: center;
		margin-left: 5px;
		padding: 5px;
		width: 48px;
	}

	.choice-tile-img {
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		height: 30px;
		width: 30px;
	}
</style>
